<template>
  <form-wizard :start-index="1" errorColor="rgba(var(--vs-danger), 1)" class="mt-8" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">

    <tab-content beforeChange title="Contact & General" class="mb-5" icon="feather icon-home" >
      <form data-vv-scope="step-1">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Site Name</small>
            <vs-input name="first_name" class="w-full required" label="" v-model="form.site_name"/>
            <span class="text-danger"></span>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Address Line 01</small>
            <vs-input  class="w-full required" label="" v-model="form.address_line1"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Address Line 02</small>
            <vs-input  class="w-full required" label="" v-model="form.address_line2"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Address Line 03</small>
            <vs-input  class="w-full required" label="" v-model="form.address_line3"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Town</small>
            <vs-input  class="w-full required" label="" v-model="form.address_town_state"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Postal Code</small>
            <vs-input  class="w-full required" label="" v-model="form.address_post_code"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Country</small>
            <vs-input  class="w-full required" label="" v-model="form.address_country"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Site Telephone</small>
            <vs-input  class="w-full required" label="" v-model="form.site_telephone"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Site Fax</small>
            <vs-input  class="w-full required" label="" v-model="form.site_fax"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Site Email</small>
            <vs-input  class="w-full required" label="" v-model="form.site_email"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Site Web Site</small>
            <vs-input  class="w-full required" label="" v-model="form.site_website"/>
          </div>
        </div>
      </vx-card>
      </form>
    </tab-content>
    <tab-content title="Manufacturing Site Details" class="mb-5" icon="feather icon-box">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Site Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Address</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Fax</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Email</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Website</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Technical Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Technical Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Technical Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Emergency Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Emergency Position</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Emergency Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Employee Details" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Staff Change Clothing</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Protective Clothing Laundered</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> PPE Worn</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col">
            <small class="label"> Staff Trained</small>
            <vs-switch class="mt-2" v-model="form.staffTrained" />
          </div>
          <div class="vx-col">
            <small class="label"> Absence</small>
            <vs-switch class="mt-2" v-model="form.adsence" />
          </div>
          <div class="vx-col">
            <small class="label"> Foreign Vacation</small>
            <vs-switch class="mt-2" v-model="form.vacation" />
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Quality" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Document Quality No</small>
            <vs-input  class="w-full required" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Document Reviewd</small>
            <vs-input  class="w-full required" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Document Registered Environment</small>
            <vs-input  class="w-full required" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">

            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">

            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Quality Management System" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Environmental" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
    <tab-content title="Ethical" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
    <tab-content title="Ellergens" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
    <tab-content title="HACCP" class="mb-5" icon="feather icon-home">
      <vx-card>
        <step-one/>
      </vx-card>
    </tab-content>
    <!--    <tab-content title="Hygiene" class="mb-5" icon="feather icon-home">-->
    <!--      <vx-card>-->
    <!--        Hello-->
    <!--      </vx-card>-->
    <!--    </tab-content>-->
    <!--    <tab-content title="Pest Control" class="mb-5" icon="feather icon-home">-->
    <!--      <vx-card>-->
    <!--        Hello-->
    <!--      </vx-card>-->
    <!--    </tab-content>-->
    <!--    <tab-content title="Transport and Storage" class="mb-5" icon="feather icon-home">-->
    <!--      <vx-card>-->
    <!--        Hello-->
    <!--      </vx-card>-->
    <!--    </tab-content>-->
  </form-wizard>
</template>

<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import { Validator } from 'vee-validate';
  import StepOne from './manufacture-form/stepOne'


  export default {
    data() {
      return {
        company_name: '',
        form: {}
      }
    },
    name: "SupplierRegister",
    methods: {
      validateStep1() {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('step-1').then(result => {
            if (result) {
              resolve(true)
            } else {
              reject("correct all values");
            }
          })
        })
      },
      formSubmitted() {

      }
    },
    components: {
      FormWizard,
      TabContent,
      StepOne
    }
  }
</script>

<style scoped>

</style>
